import { WithdrawAccountDetail } from '../../../types/mf-execution.types'
import { useBottomSheet } from '../../../state-management/contexts/BottomSheetContext'
import { BankAccountsBottomSheet } from '../../BottomSheetComponents/mf-execution/withdraw/BankAccountsBottomSheet'
import { PaymentMethodsButton } from '../PaymentMethodsButton'
import { useMemo } from 'react'
import { mfLogoBaseUrl } from '../../../env'
import { EventNames } from '../../../types/misc.types'
import { trackEvent } from '../../../utils/appBridge'

export const WithdrawPaymentMethodsButton = ({
  isDisabled,
  handleWithdrawNowClick,
  selectedBankAccount,
  handleBankAccountChange,
  bankAccounts,
  trackingFund
}: {
  isDisabled: boolean
  handleWithdrawNowClick: () => void
  selectedBankAccount: WithdrawAccountDetail | null
  handleBankAccountChange: (bankAccount: WithdrawAccountDetail | null) => void
  bankAccounts: WithdrawAccountDetail[]
  trackingFund?: { fundIsin: string; fundName: string }
}) => {
  const { openBottomSheet, closeBottomSheet } = useBottomSheet()

  const middleTexts = useMemo(() => {
    if (!selectedBankAccount) {
      return [{ type: 'WITH_DOWN_CARAT' as const, text: 'Select bank account' }]
    }

    return [
      { type: 'NORMAL' as const, text: 'Withdrawing to' },
      { type: 'WITH_DOWN_CARAT' as const, text: selectedBankAccount.displayAccNumber }
    ]
  }, [selectedBankAccount])

  const handleBankAccountsClick = () => {
    trackEvent({
      eventName: EventNames.UserClicked,
      payload: {
        ScreenName: 'Withdraw Enter amount',
        eventId: 'MFE_SELECT_AMOUNT_CTA_SELECT_BANK',
        buttonLabel: 'Bank account',
        ...(trackingFund ?? {})
      }
    })
    openBottomSheet(
      <BankAccountsBottomSheet
        onDismiss={closeBottomSheet}
        ScreenName='WithdrawPaymentPage'
        bankAccounts={bankAccounts}
        selectedBankAccount={selectedBankAccount}
        handleBankAccountChange={handleBankAccountChange}
        trackingFund={trackingFund}
      />
    )
  }

  if (!selectedBankAccount || !bankAccounts || bankAccounts.length === 0) {
    return null
  }

  return (
    <PaymentMethodsButton
      iconUrl={`${mfLogoBaseUrl}${selectedBankAccount?.logoUrl}`}
      onMiddleTextsClick={handleBankAccountsClick}
      middleTexts={middleTexts}
      onCTAClick={handleWithdrawNowClick}
      ctaLabel='Continue'
      isDisabled={isDisabled}
    />
  )
}
